import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IReportTransactionResponse } from '@bciti/types';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { State } from 'src/app/store';
import { environmentSelector } from 'src/app/store/global/global.selectors';
import { ReportsService } from './reports.service';

@Injectable({ providedIn: 'root' })
export class ReportsServiceImpl implements ReportsService {
    constructor(private store: Store<State>, private http: HttpClient) {}

    getMonthReceiptsFromOrganisation(organisationTag: string, startDate: string, endDate: string): Observable<IReportTransactionResponse[]> {
        return this.store
            .select(environmentSelector)
            .pipe(switchMap((env) => this.http.get<IReportTransactionResponse[]>(`${env.baseUrl}/cerberus/reports/${organisationTag}/${startDate}/${endDate}`).pipe(map((res) => res))));
    }
    getMonthReceiptsFromOrganisationCSV(organisationTag: string, startDate: string, endDate: string): Observable<IReportTransactionResponse[]> {
        return this.store
            .select(environmentSelector)
            .pipe(switchMap((env) => this.http.get<IReportTransactionResponse[]>(`${env.baseUrl}/cerberus/reports/${organisationTag}/${startDate}/${endDate}/CSV`).pipe(map((res) => res))));
    }
}

export const REPORTS_SERVICE_IMPL = {
    provide: ReportsService,
    useClass: ReportsServiceImpl,
};
